import React, { memo, useEffect } from "react";
import PropTypes from "prop-types";
import defaultModalStyle from "../../../common/modalStyles";

import Modal from "react-modal";

const Confirmation = memo(({
	isError, modalIsOpen, setModalIsOpen,
	title, message, onAccept, onDecline, children
}) => {
	const titleColor = `col-xs-12 titleForModal`;

	useEffect(() => {
		Modal.setAppElement(`body`);
	}, []);

	return (
		<Modal
			isOpen={modalIsOpen}
			onRequestClose={() => {
				setModalIsOpen(false);
			}}
			shouldCloseOnOverlayClick={false}
			style={defaultModalStyle.defaultModalStyle}
			contentLabel="Confirmation required"
		>
			<div className="modalLayout">
				<div className="row">
					<h1 className={titleColor}>{title}</h1>
				</div>
				<form className="form-horizontal">
					<div className="row form-group">
						<div className="col-xs-12">
							{message}
							<br/>
							{children}
						</div>
					</div>

					<div className="row form-group">
						<div className="col-xs-12">
							<div className="pull-right">
								{!isError ? <>
										<button className="btn btn-default" onClick={onDecline}>
											No
										</button>
										<button className="btn btn-primary button-spacing-left-10" onClick={onAccept}>
											Yes
										</button>
									</> :
									<button className="btn btn-primary" onClick={onDecline}>Return</button>}
							</div>
						</div>
					</div>
				</form>
			</div>
		</Modal>
	);
});
Confirmation.displayName = `DeleteAccountModal`;
Confirmation.propTypes = {
	isError: PropTypes.bool.isRequired,
	modalIsOpen: PropTypes.bool.isRequired,
	setModalIsOpen: PropTypes.func.isRequired,
	title: PropTypes.string.isRequired,
	message: PropTypes.string.isRequired,
	onAccept: PropTypes.func.isRequired,
	onDecline: PropTypes.func.isRequired,
	children: PropTypes.element
};

export default Confirmation;
